// extracted by mini-css-extract-plugin
export default {"bubble-wrapper":"cctv_bubble-wrapper__dOhqr","bubble":"cctv_bubble__vgxxJ"};